import {
    cleanCommonParams,
} from './common';

const mapCollateralCategoryParams = (
    isCreate,
    {
        slug,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            collateral_category: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapCollateralCategoryParams };
